// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__qq5Wd","count":"styles_count__wxzhe","cnt":"styles_cnt__56O-o","list":"styles_list__pu-aV","no_cnt":"styles_no_cnt__QJ+hY"};